export default __webpack_public_path__ + "assets/phone.1dac6b71.svg";